import imageUrlBuilder from '@sanity/image-url';
import { sanityClient } from './sanityClient';

const builder = sanityClient ? imageUrlBuilder(sanityClient) : null;

export function urlForImage(source) {
  if (!builder || !source) return null;
  return builder.image(source).width(1200).auto('format').quality(85).url();
}
